(ns ^:dev/always bp-clients.tv-app.nav.subs
  "Namespace for all navigation subscriptions"
  (:require
   [bp-clients.tv-app.nav.events :as nav-events]
   [re-frame.core :refer [reg-sub]]))

(defn nav-sub
  "Given the app's state. Returns the navigation."
  [db]
  (get db ::nav-events/nav))

(defn active-menu-sub
  "Given the navigation state. Returns the active-nav."
  [nav]
  (get nav :active-menu))

(defn active-page-sub
  "Given the navigation state. Returns the active-page."
  [nav]
  (get nav :active-page))

(defn error-sub
  [nav]
  (get nav :error))

(defn paywall-sub
  [nav]
  (get nav :paywall))

(defn active-playlist-sub
  "Given the navigation state. Returns the active-page."
  [nav]
  (get nav :active-playlist))

(defn active-route-sub
  "Given the navigation state. Returns the active-route and it's params."
  [nav]
  (get nav :active-route))

(defn active-page-loaded
  "Given the app's state. Returns true if the app has finished loading."
  [data]
  ((comp not nil?) data))

(defn active-page-data
  [[nav active-page active-menu active-playlist]]
  (case active-page
    :playlist (get-in nav [:data active-page active-playlist])
    (get-in nav [:data active-page active-menu])))

(defn menu-open?
  [nav]
  (true? (:menu-open? nav)))

(defn menu-items-sub
  [nav]
  (get nav :menu-items))

(defn splash-ended-sub
  [nav]
  (true? (get nav :splash-ended?)))

(defn is-network-offline-sub
  [{:keys [network-offline?]}]
  network-offline?)

(reg-sub ::nav nav-sub)
(reg-sub ::active-nav :<- [::nav] active-menu-sub)
(reg-sub ::active-route :<- [:nav] active-route-sub)
(reg-sub ::active-page :<- [::nav] active-page-sub)
(reg-sub ::active-playlist :<- [::nav] active-playlist-sub)
(reg-sub ::active-page-data :<- [::nav] :<- [::active-page] :<- [::active-nav] :<- [::active-playlist] active-page-data)
(reg-sub ::active-page-loaded? :<- [::active-page-data] active-page-loaded)
(reg-sub ::menu-open? :<- [::nav] menu-open?)
(reg-sub ::menu-items :<- [::nav] menu-items-sub)
(reg-sub ::error :<- [::nav] error-sub)
(reg-sub ::paywall :<- [::nav] paywall-sub)
(reg-sub ::splash-ended? :<- [::nav] splash-ended-sub)
(reg-sub ::network-offline? is-network-offline-sub)
